/**
 * Created by Aleksandr on 21.09.2022.
 */

const Map2dAdviceRefillLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);
};

Map2dAdviceRefillLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceRefillLogic.prototype.constructor = Map2dAdviceRefillLogic;

Map2dAdviceRefillLogic.prototype.findMove = function () {
    const unit = this.listAvailableUnits()[0];
    const move = {};

    if (unit && unit.findComponent(Tank)) {
        move.cells = [cc.p(unit.x, unit.y)];
        move.highlight = move.cells;
        move.arrow = move.cells[0];
    }

    const currentWindow = cleverapps.focusManager.currentWindow();
    if (currentWindow instanceof RefillTankWindow && unit.findComponent(Tank)) {
        move.window = Map2d.REFILL;
    }

    if (move.cells || move.window) {
        return move;
    }
};
